import { render, staticRenderFns } from "./RegisterByOauth.vue?vue&type=template&id=2a850a76&scoped=true"
import script from "./RegisterByOauth.vue?vue&type=script&lang=js"
export * from "./RegisterByOauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a850a76",
  null
  
)

export default component.exports